//v1.0 - HTML loader for loading HTML items in
import { DataLoader } from './DataLoader';

export class HTMLLoader extends DataLoader {
	public element: Element;
	public html: string;

	protected dataLoadComplete(response: any): void {
		this.html = response.data;

		if (this.element) {
			this.element.innerHTML = this.html;
		}

		this.complete(this.id);
	}
}
